import App from './components/App.jsx';

const routes = {
	path: '/ga',
	component: App,
	childRoutes: []
};

export default routes;


// WEBPACK FOOTER //
// ./D:/Repos/university/my-composer/app/routes.jsx